@if(config.type == 'select'){
<mat-form-field appearance="outline" [style.width]="config.width" subscriptSizing="dynamic">
    <mat-icon matPrefix>{{ getTypeIcon('select') }}</mat-icon>
    <mat-label>{{ config.label | translate }}</mat-label>

    @if(config.multiple) {
    <mat-select matInput [(ngModel)]="config.value" (selectionChange)="onValueChange($event)" multiple>
        @for(opt of config.options; track opt){
        <mat-option [value]="opt">{{ opt }}</mat-option>
        }
    </mat-select>
    } @else {
    <mat-select matInput [(ngModel)]="config.value" (selectionChange)="onValueChange($event)">
        @for(opt of config.options; track opt){
        <mat-option [value]="opt">{{ opt }}</mat-option>
        }
    </mat-select>
    }
</mat-form-field>

} @else if(config.type == 'text'){
<mat-form-field appearance="outline" class="" [style.width]="config.width" subscriptSizing="dynamic">
    <mat-icon matPrefix>{{ getTypeIcon('text') }}</mat-icon>
    <mat-label>{{ config.label | translate }}</mat-label>

    <input matInput type="text" [placeholder]="config.placeholder || ''" [(ngModel)]="config.value"
        (change)="onValueChange($event)" />
</mat-form-field>

} @else if(config.type == 'number'){
<mat-form-field appearance="outline" class="" [style.width]="config.width" subscriptSizing="dynamic">
    <mat-icon matPrefix>{{ getTypeIcon('number') }}</mat-icon>
    <mat-label>{{ config.label | translate }}</mat-label>
    <input matInput type="number" placeholder="0" [(ngModel)]="config.value"
        [min]="config.min !== undefined ? config.min : null" [max]="config.max !== undefined ? config.max : null"
        (change)="onValueChange($event)" />
</mat-form-field>

} @else if(config.type == 'password'){
<mat-form-field appearance="outline" class="" [style.width]="config.width" subscriptSizing="dynamic">
    <mat-icon matPrefix>{{ getTypeIcon('password') }}</mat-icon>
    <mat-label>{{ config.label | translate }}</mat-label>
    <input matInput type="password" [placeholder]="config.placeholder || ''" [(ngModel)]="config.value"
        (change)="onValueChange($event)" />
</mat-form-field>

} @else if(config.type == 'date'){
<app-date-picker [startDate]="config.value || defaultDate" [label]="config.label"  (dateChanged)="onDateChanged($event)">
</app-date-picker>

} @else if(config.type == 'datetime'){
<mat-form-field [style.width]="config.width" outline="fill" subscriptSizing="dynamic">
    <mat-label>{{config.label}}</mat-label>
</mat-form-field>

} @else if(config.type == 'checkbox'){
<mat-checkbox [(ngModel)]="config.value" (change)="onValueChange($event)" [style.width]="config.width || '250px'"
    class="checkbox-input">
    {{ config.label | translate }}
</mat-checkbox>

} @else if(config.type == 'radio'){
<div [style.width]="config.width">
    <div class="input-label-group">
        <label style="display: block; width: 100%">{{
            config.label | translate
            }}</label>
        <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="config.value"
            (change)="onValueChange($event)" [style.width]="config.width">
            @for(opt of config.options; track opt.name){
            <mat-radio-button class="radio-button" *ngFor="let opt of config.options" [value]="opt.value">{{
                opt.name | translate }}</mat-radio-button>
            }
        </mat-radio-group>
    </div>

    <!-- <div class="group box-input" *ngIf="config.groupKey && config.value">
            <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{
          inputs: groups[config.group + '_' + config.value]
        }">
            </ng-container>
        </div> -->
</div>
}
<!-- @else if(config.type == 'colors'){
    <div class="colors" [style.width]="config.width">
        <label style="display: block; width: 100%">{{
            config.label | translate
            }}</label>
        <div class="color-container" [style.width]="config.width">
            <div class="color-item" *ngFor="let color of config.options; let index = index">
                <div class="color-select">
                    <input type="color" class="color-input" name="color" [(ngModel)]="color.value"
                        (change)="config.update($event, index, 'color')" />

                    <mat-icon class="color-arrow" [matMenuTriggerFor]="colorList">keyboard_arrow_down</mat-icon>

                    <mat-menu #colorList="matMenu">
                        <div class="color-list">
                            <div class="color-circle" *ngFor="let _color of colors" [style.backgroundColor]="_color"
                                (click)="selectColor(config, index, _color)"></div>
                        </div>
                    </mat-menu>
                </div>

                <mat-form-field appearance="outline" class="" [style.width]="'200px'" subscriptSizing="dynamic">
                    <input matInput type="text" [(ngModel)]="color.label"
                        (change)="config.update($event, index, 'label')" />
                </mat-form-field>
            </div>
        </div>
    </div>
}  -->
<!-- @else if(config.type == 'color'){
    <div class="color-item" [style.width]="config.width">
        <div class="color-select">
            <input type="color" class="color-input" [(ngModel)]="config.value" name="color"
                (change)="config.update($event)" />
            <mat-icon class="color-arrow" [matMenuTriggerFor]="colorList">keyboard_arrow_down</mat-icon>

            <mat-menu #colorList="matMenu">
                <div class="color-list">
                    <div class="color-circle" *ngFor="let _color of colors" [style.backgroundColor]="_color"
                        (click)="selectColor(config, null, _color)"></div>
                </div>
            </mat-menu>
        </div>
        <label style="display: block; width: 100%">{{
            config.label | translate
            }}</label>
    </div>
}  -->
<!-- @else if(config.type == 'button'){
    <div [style.width]="config.width">
        <button mat-flat-button color="primary" (click)="handleAction(config.action)">
            {{ config.label | translate }}
        </button>
    </div>
} -->